var ScenarioStatus = /* @__PURE__ */ ((ScenarioStatus2) => {
  ScenarioStatus2["Completed"] = "Completed";
  ScenarioStatus2["Exited"] = "Exited";
  ScenarioStatus2["Canceled"] = "Canceled";
  return ScenarioStatus2;
})(ScenarioStatus || {});
var ScenarioType = /* @__PURE__ */ ((ScenarioType2) => {
  ScenarioType2["NetworkRequest"] = "NetworkRequest";
  ScenarioType2["Polling"] = "Polling";
  return ScenarioType2;
})(ScenarioType || {});
export {
  ScenarioStatus,
  ScenarioType
};
//# sourceMappingURL=ScenarioLoggingProvider.types.js.map
